export const theme = {
  palette: {
    primary: {
      // Czerwień marki iSA (--isa-red), ta sama co w ankiecie 1.4.0 (isa-surveys, src/theme.js).
      // Biały tekst na niej ma kontrast 5,81:1 (WCAG AA dla zwykłego tekstu wymaga 4,5:1);
      // dotąd był zielony #359b98 dostawcy (biały tekst: 3,37:1, poniżej AA).
      main: '#CB092A',
    },
    secondary: {
      main: '#ae0193',
    },
    error: {
      // Domyślny czerwony MUI (#f44336) ma na białym 3,68:1 - za mało dla tekstu błędów walidacji.
      main: '#CB092A',
    },
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
  },
}

export default theme
